import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { VoipEntity } from '../../models/entity/voip.model';
import { VoipVendorModel } from '../../models/entity/voip-vendor.model';
import { throwError as observableThrowError, Observable } from "rxjs";
import { catchError } from 'rxjs/operators';
import { BaseRestService } from '../base-rest.service';
import { SessionStorageService } from '../session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class VoipService extends BaseRestService {
  constructor(protected httpClient: HttpClient, protected sessionStorageService: SessionStorageService) {
    super(httpClient, sessionStorageService);
  }

  // Santraller
  getVoipVendors(): Observable<VoipVendorModel[]> {
    const url = `/voip-vendors`;
    return this.httpGet<VoipVendorModel[]>(url)
      .pipe(catchError(this.errorHandler));
  }

  // Santraller
  getVoips(): Observable<VoipEntity[]> {
    const url = `/voips`;
    return this.httpGet<VoipEntity[]>(url)
      .pipe(catchError(this.errorHandler));
  }

  //santral ekle
  addVoip(data) {
    const url = `/voips`;
    return this.httpPost<VoipEntity>(url, data)
      .pipe(catchError(this.errorHandler));
  }

  //Santral güncelle
  updateVoip(id, data): Observable<VoipEntity> {
    const url = `/voips/${id}`;
    return this.httpPut<VoipEntity>(url, data)
      .pipe(catchError(this.errorHandler));
  }


  //Santral sil
  deleteVoip(id) {
    const url = `/voips/${id}`;
    return this.httpDelete(url).pipe(catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    // console.log("service:"+error);
    return observableThrowError(error);
  }
}
